const release = {
  commit: "85549544923114ce61bb0d22ac189c46eee206a6",
  version: "202404.190034.25",
};

export default release;
